<div *ngIf="!showContent" class="loading-spinner">
    <mat-spinner></mat-spinner>
</div>

<ng-container *ngIf="showContent">
    <mat-tab-group>
        <mat-tab label="Details">
            <form [formGroup]="detailsForm">
                <div class="tab-container">
                    <div class="tab-section">
                        <h2 style="background-color: rgb(125, 11, 160); color: white; text-align: center; font-size: 14px;" ><i style="font-size: 15px;" class="fa-solid fa-envelope"></i>&nbsp;PCES Client EMAIL Details</h2>
                        <div class="tab-grid-template">
                            <mat-form-field>
                                <mat-label>Client Name</mat-label>
                                <input matInput formControlName="clientname">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Client Email</mat-label>
                                <input matInput formControlName="email">
                            </mat-form-field>
                        </div>
                        <div style="display: flex; flex-wrap: wrap; width: 50%; gap: 10px;">
                            <button (click)="editEmail()" style="width: 100%; background-color: rgb(7, 170, 20); " mat-raised-button color="primary" [hidden]="editEnabled">
                                <i style="font-size: 15px;"  class="fas fa-edit"></i>&nbsp;Edit Details
                            </button>
                            <button (click)="saveEmail()" style="width: 100%; background-color: rgb(4, 71, 34); " mat-raised-button color="primary" [hidden]="!editEnabled">
                                <i style="font-size: 15px;"  class="fas fa-save"></i>&nbsp;Save Changes To Details
                            </button>
                            <button (click)="deleteEmail()" style="width: 100%; background-color: rgb(187, 7, 52); " mat-raised-button color="primary">
                                <i style="font-size: 15px;"  class="fas fa-trash"></i>&nbsp;Delete Email
                            </button>
                        </div>                              
                    </div>
                </div>
            </form>
        </mat-tab>
        <mat-tab label="Emails">
            <ag-grid-angular style="height: 270px; margin:20px" class="ag-theme-alpine" [columnDefs]="emailColumnDefs"
                [rowData]="emails" 
                [defaultColDef]="defaultColDef"></ag-grid-angular>
        </mat-tab>        
    </mat-tab-group>
</ng-container>